import angular from 'angular';
import templateUrl from './principal-check-config.html';

export const checkConfig = {
    templateUrl,

    bindings: {
        principalId: '<'
    },

    controller: class CheckConfigController {
        /*@ngInject*/
        constructor($translate, logger, PrincipalsDA) {
            this.$translate = $translate;
            this.logger = logger;
            this.PrincipalsDA = PrincipalsDA;

            // Résultat des vérifications
            this.result = null;
            // ID de la tâche asynchrone de vérification de la config
            this.taskId = null;
        }

        startCheckConfig() {
            if (this.taskId) return;

            this.PrincipalsDA.execPrincipalCheckConfig(this.principalId).then(
                taskId => (this.taskId = taskId),
                () => this.logger.error('error.generic')
            );
        }

        onTaskEnd(asyncResult) {
            this.taskId = null;

            if (asyncResult.success) {
                this.result = asyncResult.result;
            } else if (asyncResult.error.message) {
                this.logger.error('error.generic', asyncResult.error.message);
            } else {
                this.logger.error('error.generic', asyncResult);
            }
        }

        translateMessage(message) {
            return this.$translate.instant(
                'principal.check_configuration.' + angular.lowercase(message.errorCode),
                message.parameters
            );
        }
    }
};
